import { render, staticRenderFns } from "./simpleBox.vue?vue&type=template&id=ead99cb2&"
import script from "./simpleBox.vue?vue&type=script&lang=js&"
export * from "./simpleBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports